// extracted by mini-css-extract-plugin
export default {"page":"App_page__RUjZ7","scroll_progress":"App_scroll_progress__h9QYo","flareAnimation":"App_flareAnimation__s9knN","shine":"App_shine__i9eOz"};